import styled from 'styled-components';

export default styled.div`
  display: ${props => props.inline ? 'inline-block' : 'block'};
  height: ${props => props.height ? `${props.height}px` : 0};
  width: ${props => props.width ? `${props.width}px` : 0};
`;
